import { BaseModel } from "@/models/base";

export enum DaeSituacao {
  EMITIDO = "EMITIDO",
  PAGO = "PAGO",
  CANCELADO = "CANCELADO",
}

export enum SituacaoMulta {
  EMITIDA = "EMITIDA",
  PAGA = "PAGA",
  CANCELADA = "CANCELADA",
}

export interface MultaAdministrativaFilter {
  cnpj: string;
  mesCompetencia?: string | null;
  dataVencimentoDe?: string | null;
  dataVencimentoAte?: string | null;
  valorPrincipalDe?: string | number | null;
  valorPrincipalAte?: string | number | null;
  nup?: string | null;
  autoInfracao?: string | null;
  page: number;
  size: number;
  sortBy?: string | null;
  sortOrder?: string | null;
}

export class MultaAdministrativa extends BaseModel {
  constructor(
    public id: number = 0,
    public mesCompetencia?: string | null,
    public dataVencimento?: string | null,
    public valorPrincipal?: number | null,
    public nup?: string | null,
    public autoInfracao?: string | null,
    public situacaoMulta?: SituacaoMulta | null,
    public daeSituacao?: DaeSituacao | null,
    public dae?: string | null,
    public dataVencimentoDae?: string | null
  ) {
    super(id);
  }
}
